// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__kf4LD","primary":"Button_primary__Q2Cf4","secondary":"Button_secondary__H1dsd","clean":"Button_clean__A9gr7"};